import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isHighlighted", "children", "style"];

/** @jsx jsx */
import { forwardRef } from 'react';
import { css, jsx } from '@emotion/core';
import { tableRowCSSVars as cssVars } from './DynamicTable';
var rowStyles = css({
  '&:focus': {
    outline: "2px solid ".concat("var(--ds-border-focused, ".concat("var(".concat(cssVars.CSS_VAR_HOVER_BACKGROUND, ")"), ")")),
    outlineOffset: "-2px"
  }
});
var rowBackgroundStyles = css({
  '&:hover': {
    backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat("var(".concat(cssVars.CSS_VAR_HOVER_BACKGROUND, ")"), ")")
  }
});
var rowHighlightedBackgroundStyles = css({
  backgroundColor: "var(--ds-background-selected, ".concat("var(".concat(cssVars.CSS_VAR_HIGHLIGHTED_BACKGROUND, ")"), ")"),
  '&:hover': {
    backgroundColor: "var(--ds-background-selected-hovered, ".concat("var(".concat(cssVars.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND, ")"), ")")
  }
});
export var TableBodyRow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isHighlighted = _ref.isHighlighted,
      children = _ref.children,
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, _excluded);

  return jsx("tr", _extends({
    style: style,
    css: [rowStyles, isHighlighted ? rowHighlightedBackgroundStyles : rowBackgroundStyles]
  }, rest, {
    ref: ref
  }), children);
});